module.exports = __webpack_public_path__ + "img/securityConfig.b3c91fd6.svg";